import { useEffect, useMemo } from 'react'
import { FlowMetaData } from '../../../@types/types'
import { loadFeature } from '../../../api/features/featuresApi'
import { getDefaultLogger } from '../../../services/logger/logger'
import { useFeatureSwitch } from '../../../utils/features/FeatureSwitchContext'
import { FeatureSwitch } from '../../../utils/features/featureSwitches'
import { getHeyImmoExperimentState } from '../../../utils/features/heyImmoExperiment'

export function useHeyImmoExperimentTracking(isHeyImmoSupported: boolean, flowMetadata?: FlowMetaData) {
  const { value: heyImmoFeatureValue, isLoadedFromBackend: isHeyImmoFeatureLoadedFromBackend } = useFeatureSwitch(
    FeatureSwitch.PPA_12798_HEYIMMO
  )

  useEffect(() => {
    if (!isHeyImmoSupported || !flowMetadata || !isHeyImmoFeatureLoadedFromBackend) {
      return
    }

    void loadFeature(FeatureSwitch.PPA_12798_HEYIMMO, flowMetadata).catch((error) => {
      getDefaultLogger().warn('HeyImmo feature impression could not be sent', error)
    })
  }, [flowMetadata, isHeyImmoFeatureLoadedFromBackend, isHeyImmoSupported])

  return useMemo(
    () =>
      getHeyImmoExperimentState({
        isHeyImmoSupported,
        isHeyImmoFeatureLoadedFromBackend,
        heyImmoFeatureValue,
      }).trackingParameters,
    [heyImmoFeatureValue, isHeyImmoFeatureLoadedFromBackend, isHeyImmoSupported]
  )
}
